<template>
  <div
    class="purchase-sticky"
    :class="{
      reduced: reducePurchase && !forceFull,
      'has-full-page-modal': modal.show || showTestimonialsModal,
      'size-selector-open': showSizeSelector,
    }"
  >
    <div class="overlay" @click="handleOverlayClick" />
    <div class="purchase__top d-flex justify-space-between align-center">
      <div></div>
      <!-- <div class="purchase__market d-flex align-center mb-0-2">
        <span>{{ $t('purchase.already') }}</span>
        <number-animated
          ref="number"
          :from="numberOfSells.from"
          :to="numberOfSells.to"
          :duration="0.5"
          @complete="numberOfSells.from = numberOfSells.to"
        />
        <span>{{ $t('purchase.preco') }}</span>
      </div> -->

      <button
        class="button-as-link button-reducer"
        @click="handleReducePurchaseSticky"
      >
        <span class="visually-hidden">{{ $t('action.reduce') }}</span>

        <icon name="carret-down" class="text-color-tertiary" />
      </button>
    </div>
    <div class="purchase__inner">
      <transition name="fade">
        <div
          class="purchase__title d-flex justify-space-between align-center pt-0-4 pl-0-4 pr-0-4"
        >
          <h1 class="text-color-tertiary text-secondary">
            {{ productDocument.title }}
          </h1>

          <div
            v-if="productDocument && shopifyProduct"
            class="prices d-flex align-center"
          >
            <price :price="price" class="text-color-tertiary" />

            <price :compare="true" :price="compareAtPrice" />
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div
          class="purchase__selectors d-flex justify-space-between align-start pt-0-6 pl-0-4 pr-0-4"
        >
          <div ref="purchaseColors" class="purchase__colors">
            <color-picker
              v-if="colorsDimension.length > 1"
              v-model="selectedDimensions.color"
              :colors="colorsDimension"
              :product-document="productDocument"
              with-label
              @input="onColorChange"
            />
          </div>

          <div class="purchase__size-selector">
            <p class="picker__label text-big text-secondary mb-0-8">
              <span>{{ $t('label.size_only') }}</span>
            </p>

            <button
              class="purchase__size-picker"
              @click="handleShowSizeSelector"
            >
              <span
                class="inner d-flex align-center justify-center text-color-tertiary text-extra-small w-600"
              >
                <span v-if="selectedVariant">
                  {{ selectedVariant.opt.size.label }}
                </span>
                <span v-else>
                  {{ $t('action.choose') }}
                </span>

                <icon name="carret-down" />
              </span>
            </button>
          </div>
        </div>
      </transition>

      <transition name="appear-top">
        <error-text
          v-if="errors.size !== ERRORS_TYPE.NONE"
          :text="$t(`purchase.errors.size.${errors.size}`)"
          class="text-right mb-0-6 pr-0-4"
        />
      </transition>

      <div class="d-flex pt-0-6">
        <primary-button
          id="AddToCart"
          :text="actionText"
          align="center"
          type="button"
          :loading="cartLoading"
          :error="onError"
          :skeleton="!isRefreshed"
          no-shadow
          class="add-to-cart"
          @click="addToCart"
        />
      </div>

      <transition name="appear-top">
        <error-block
          v-if="errors.addToCart !== ERRORS_TYPE.NONE"
          class="mt-0-6"
        >
          <p
            class="mb-0"
            v-html="$t(`purchase.errors.addToCart.${errors.addToCart}`)"
          />
        </error-block>
      </transition>
    </div>

    <transition name="fade">
      <div class="purchase__bottom d-flex justify-space-between align-center">
        <button @click="handleShowModal('delivery')">
          <div
            class="d-flex align-center text-color-tertiary text-extra-small text-underline w-600 mb-0 pt-0-6 pb-0-6"
          >
            <icon name="box" class="mr-0-2" />
            <span v-if="productStatus === STATUS.PRECOMMANDE">
              {{ $t('purchase.estimated_delivery_small') }}
              <span
                v-if="!isRefreshed"
                class="skeleton skeleton--bar d-inline-block"
                style="width: 100px; vertical-align: middle"
                >&nbsp;</span
              >
              <span v-else
                >{{ $t('purchase.between_small', deliveryText.options)
                }}<span v-if="deliveryText.ref === 'noDays'">{{
                  $t('purchase.contactCare')
                }}</span></span
              >
            </span>
            <span v-else>
              {{ $t('purchase.delivery') }}&nbsp;{{ $t('purchase.fewDays') }}
            </span>
          </div>
        </button>

        <button
          v-if="hasTertimonials"
          class="d-flex align-center text-extra-small text-color-tertiary w-600 text-underline mb-0 pt-0-6 pb-0-6"
          @click="handleShowTestimonials"
        >
          <icon name="favorite" class="mr-0-2" />
          <span>
            <span>{{ productDocument.rating_average }}/5</span>
            <span>({{ productDocument.rating_number }} avis)</span>
          </span>
        </button>
      </div>
    </transition>

    <purchase-modal
      title="Choisir une taille"
      :show="showSizeSelector"
      @hide="handleHideModal"
    >
      <template #top-label>
        <p class="picker__label mb-0 mr-1">
          <span> {{ $t('label.color') }}</span>
          <span>{{ colorName }}</span>
        </p>
      </template>

      <template #error>
        <transition name="appear-top">
          <error-text
            v-if="errors.size !== ERRORS_TYPE.NONE"
            :text="$t(`purchase.errors.size.${errors.size}`)"
            class="text-center mb-0-6 pr-0-4"
          />
        </transition>
      </template>

      <template #content>
        <div
          class="size-picker pt-0-6 pb-0-6 pl-1 pr-1"
          :class="{
            'size-picker--errors': errors.size !== ERRORS_TYPE.NONE,
          }"
        >
          <button
            v-for="size in sizesDimension"
            :key="size.id"
            class="size-picker__item"
            :class="{
              'size-picker__item--active':
                selectedVariant && selectedVariant.id === size.id,
            }"
            @click="handleSelectSize(size.opt.size.value)"
          >
            <span>
              {{ size.opt.size.label }}
            </span>
          </button>
        </div>
      </template>

      <template #bottom>
        <div class="d-flex align-center justify-space-between pl-1 pr-1">
          <button class="button-as-link" @click="handleShowModal('size')">
            <div
              class="d-flex align-center text-label w-600 text-uppercase lh-1 mb-0 pt-1 pb-1"
            >
              <ceintre-icon style="width: 1rem; height: 1rem" class="mr-0-4" />
              <span>{{ $t('purchase.size-guide') }}</span>
            </div>
          </button>

          <div id="kleep-module-sizing"></div>
        </div>

        <div class="d-flex ml-1 mr-1">
          <primary-button
            id="AddToCartSize"
            :text="actionText"
            align="center"
            type="button"
            :loading="cartLoading"
            :error="onError"
            :skeleton="!isRefreshed"
            no-shadow
            class="add-to-cart"
            @click="addToCart"
          />
        </div>

        <transition name="appear-top">
          <error-block
            v-if="errors.addToCart !== ERRORS_TYPE.NONE"
            class="mt-0-6 ml-1 mr-1"
          >
            <p
              class="mb-0"
              v-html="$t(`purchase.errors.addToCart.${errors.addToCart}`)"
            />
          </error-block>
        </transition>
      </template>
    </purchase-modal>

    <purchase-modal
      :title="$t('product.testimonials.title')"
      :show="showTestimonialsModal"
      full-page
      @hide="handleHideModal"
    >
      <template #top>
        <div class="purchase-testimonials d-flex align-end">
          <div>
            <p class="global-note mb-0-4">
              <strong class="h1 text-secondary mb-0">{{
                productDocument.rating_average
              }}</strong
              ><span class="text-small">&nbsp;/ 5</span>
            </p>

            <stars :value="productDocument.rating_average" />
          </div>

          <div class="separator"></div>

          <div class="flex-grow-1">
            <p
              class="text-extra-small lh-1-2 mb-0-4"
              v-html="
                $t('product.testimonials.number', {
                  number: productDocument.rating_number,
                })
              "
            />

            <p class="text-extra-small lh-1-2 mb-0">
              {{ $t('product.testimonials.text') }}
            </p>
          </div>
        </div>
      </template>

      <template #content>
        <testimonials-list
          v-if="showTestimonialsModal"
          :product-document="productDocument"
          class="pt-0-6 pl-1 pr-1 pb-1"
        />
      </template>
    </purchase-modal>

    <purchase-modal
      :title="modal.show ? $t(`purchase.modal.${modal.type}`) : ''"
      :show="modal.show"
      full-page
      class="purchase-modal--delivery"
      @hide="handleHideModal"
    >
      <template #content>
        <transition mode="out-in" name="fade">
          <div v-if="modal.loading" class="mt-1">
            <p class="d-flex justify-center align-center">
              <loading-icon class="mr-0-6" />
              <span>{{ $t('loading') }}</span>
            </p>
          </div>

          <div v-else-if="modal.content">
            <blocks
              v-if="modal.content.blocks"
              :blocks="modal.content.blocks"
              :entities="{
                activeSize:
                  selectedVariant && selectedVariant.opt.size
                    ? selectedVariant.opt.size.value
                    : null,
              }"
            />
          </div>
        </transition>
      </template>
    </purchase-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Price from '@/components/Price/Price'
import ColorPicker from '@/components/picker/ColorPicker'
import PrimaryButton from '@/components/buttons/Primary'
import Icon from '@/components/icons/Icon'
import LoadingIcon from '@/components/icons/Loading'
import CeintreIcon from '@/components/icons/Ceintre'
import Blocks from '@/components/blocks/Blocks'
import Stars from '@/components/stars/Stars'

import PurchaseModal from '@/components/modal/PurchaseModal'

import ErrorText from '@/components/errors/Text'
import ErrorBlock from '@/components/errors/Block'

import { PRODUCT_COLOR_STATUS } from '@/entities/sanity/product'

import { ERRORS_TYPE, SHOPIFY_TYPES, SS_UPSELLS_ITEMS, STATUS } from '@/const'
import { EVENTS } from '@/const/events'

import DeliveryMixin from '@/mixins/deliveryText'

import services from '@/services'

import { getSanityBunnyImageLink } from '@/utils/image'
import ShopifyBase64 from '@/utils/shopifyBase64'

export default {
  name: 'PurchaseSticky',
  components: {
    Price,
    ColorPicker,
    PrimaryButton,
    ErrorText,
    ErrorBlock,
    Icon,
    LoadingIcon,
    Blocks,
    CeintreIcon,
    PurchaseModal,
    Stars,
    TestimonialsList: () =>
      import(
        '@/components/testimonials/List' /* webpackChunkName: 'testimonials_list' */
      ),
    // NumberAnimated: () => ({
    //   component: import(
    //     '@/components/number/Number' /* webpackChunkName: 'animated_number' */
    //   ),
    // }),
  },
  mixins: [DeliveryMixin],
  props: {
    productDocument: { type: Object, required: true },
    shopifyProduct: { type: Object, required: true },
    forceFull: { type: Boolean, default: false },
    productAbTest: { type: Boolean, default: null },
  },
  data() {
    return {
      ERRORS_TYPE,
      STATUS,
      selectedDimensions: {
        color: this.getSelectedColorKey(),
        size: this.getSelectedSize(),
      },
      numberOfSells: { from: 0, to: 0 },
      isRefreshed: true,
      errors: {
        size: ERRORS_TYPE.NONE,
        addToCart: ERRORS_TYPE.NONE,
      },
      reducePurchase: false,
      showSizeSelector: false,
      showTestimonialsModal: false,

      modal: {
        show: false,
        type: '',
        loading: false,
        content: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      cart: 'cart/cart',
      cartLoading: 'cart/isLoading',
      authenticated: 'auth/authenticated',
      customer: 'auth/customer',
      connectedEmail: 'subscriptions/connectedEmail',
    }),

    productStatus() {
      if (this.shopifyProduct.hasDates) {
        return this.shopifyProduct.isSaleableAsStock
          ? STATUS.STOCK
          : STATUS.AGENDA
      }

      return this.productDocument.status
    },
    orderType() {
      if (this.productStatus === STATUS.PRECOMMANDE) {
        return 'preorder'
      }
      return 'stock'
    },
    productIsOnSale() {
      if (this.shopifyProduct.hasDates) {
        return this.shopifyProduct.isSaleableAsStock
      }

      return isProductSaleable(this.productDocument)
    },

    /**
     * Prix du produit
     */
    price() {
      if (!this.shopifyProduct) {
        return null
      }

      if (this.selectedDimensions.color) {
        return this.shopifyProduct.priceByDimension(
          'color',
          this.selectedDimensions.color
        )
      }

      return this.shopifyProduct.price
    },
    compareAtPrice() {
      if (!this.shopifyProduct) {
        return null
      }

      if (this.selectedDimensions.color) {
        return this.shopifyProduct.compareAtPriceByDimension(
          'color',
          this.selectedDimensions.color
        )
      }

      return this.shopifyProduct.compareAtPrice
    },

    /**
     * Couleurs
     */
    colorName() {
      if (!this.productDocument.colors && !this.selectedDimensions.color) {
        return null
      }

      const color = this.productDocument.colors.find(
        (color) => color._key === this.selectedDimensions.color
      )

      return color ? color.name : null
    },
    colorsDimension() {
      const cc = []

      for (const color of this.productDocument.colors) {
        if (
          this.shopifyProduct.isDimensionHasValue(
            'color',
            this.getColorFromColorKey(color._key)
          )
        ) {
          if (!cc.some((c) => c.value === color._key)) {
            const label =
              this.productDocument.shopify_product.colorOptions.find(
                (colorOption) => colorOption._key === color._key
              )?.name || color.label

            const c = {
              value: this.getColorFromColorKey(color._key),
              label,
              isNew: color.color_status === PRODUCT_COLOR_STATUS.NEW,
              isLeavingSoon:
                color.color_status === PRODUCT_COLOR_STATUS.LEAVING_SOON,
              image: {
                url: getSanityBunnyImageLink(color.thumbnail, {
                  width: 100,
                  height: 100,
                }),
                dimensions: {
                  width: 100,
                  height: 100,
                },
              },
            }

            c.available = this.shopifyProduct.isDimensionAvailable(
              'color',
              c.value
            )

            cc.push(c)
          }
        }
      }

      return cc
    },

    /**
     * Taille
     */
    sizesDimension() {
      if (this.selectedDimensions.color !== '') {
        return this.shopifyProduct.filterVariantsByDimension(
          'color',
          this.selectedDimensions.color
        )
      }

      return []
    },

    /**
     * Variante sélectionnée
     */
    selectedVariant() {
      return this.shopifyProduct.variants.find(
        (v) =>
          v.opt.color.value === this.selectedDimensions.color &&
          v.opt.size.value === this.selectedDimensions.size
      )
    },

    /**
     * Date de livraison
     */
    delivery() {
      return this.shopifyProduct.metafield
        ? new Date(this.shopifyProduct.metafield)
        : undefined
    },
    deliveryText() {
      if (
        this.productStatus === STATUS.PRECOMMANDE &&
        this.delivery &&
        !isNaN(this.delivery.getTime())
      ) {
        return this.getDeliveryFromDate(this.delivery)
      }

      if (this.productStatus === STATUS.STOCK) {
        return { ref: 'purchase.fewDays', options: {} }
      }

      return { ref: 'purchase.noDays', options: {} }
    },

    /**
     * Render Computed
     */
    hasTertimonials() {
      return (
        this.productDocument.rating_average !== null &&
        this.productDocument.rating_number !== null
      )
    },
    actionText() {
      if (this.productStatus === STATUS.STOCK) {
        return this.$t('action.buy')
      }

      return this.$t('action.preorder')
    },
    onError() {
      if (
        this.errors.size !== ERRORS_TYPE.NONE ||
        this.errors.addToCart !== ERRORS_TYPE.NONE
      ) {
        return true
      }

      return false
    },

    /**
     * From user state
     */
    productHasBeenAccessedFromUpsell() {
      if (process.client) {
        let upsellsId = window.sessionStorage.getItem(SS_UPSELLS_ITEMS)
        if (upsellsId) {
          upsellsId = JSON.parse(upsellsId)
          return (
            upsellsId.includes(this.shopifyProduct.id) ||
            this.$route.query.upsell === 'true'
          )
        }
      }
      return this.$route.query.upsell === 'true'
    },
  },
  watch: {
    showSizeSelector(val) {
      if (val) {
        this.$track.openPurchaseSizeSelector()
      }
    },
    showTestimonialsModal(val) {
      if (val) {
        this.$track.openPurchaseTestimonials()
      }
    },
    selectedVariant() {
      this.setVariantUrlParam()
    },
  },
  beforeDestroy() {
    this.$nuxt.$off(EVENTS.OPEN_TESTIMONIAL_MODAL)
  },
  created() {
    this.numberOfSells = {
      from: 0,
      to:
        this.shopifyProduct.totalInventory + this.productDocument.stock_initial,
    }
  },
  mounted() {
    this.updateHasColorsOverflow()

    this.initKleep()

    this.init()
  },
  methods: {
    ...mapActions({
      addItemToCart: 'cart/addItems',
    }),
    /**
     * Permet d'extraire la couleur de la clé couleur d'un productDocument.colors[]_key
     * @param colorKey La clé de la couleur (avec ou sans la 3ème dimension) selon le format "third__color"
     * @returns La couleur correspondante
     */
    getColorFromColorKey(colorKey) {
      return this.hasThirdDimension ? colorKey.split('__')[1] : colorKey
    },
    /**
     * Permet d'extraire la troisième dimension de la clé couleur d'un productDocument.colors[]_key
     * @param colorKey La clé de la couleur (avec ou sans la 3ème dimension) selon le format "third__color"
     * @returns La third correspondante
     */
    getThirdFromColorKey(colorKey) {
      return this.hasThirdDimension ? colorKey.split('__')[0] : colorKey
    },

    getSelectedColorKey() {
      let selectedColor =
        this.productDocument.colors && this.productDocument.colors[0]
          ? this.productDocument.colors[0]._key
          : null

      if (this.$route.query.color && selectedColor) {
        const c = this.productDocument.colors.find(
          (color) => color._key === this.$route.query.color
        )

        if (c) {
          selectedColor = c._key
        }
      }

      if (this.$route.query.variant && this.shopifyProduct && selectedColor) {
        const variant = this.shopifyProduct.variants.find(
          (v) => v.id === parseInt(this.$route.query.variant)
        )

        if (
          variant &&
          this.productDocument.colors.some(
            (c) => c._key === variant.opt.color.value
          )
        ) {
          selectedColor = variant.opt.color.value
        }
      }

      return selectedColor
    },
    getSelectedSize() {
      let selectedSize = null
      if (this.$route.query.variant) {
        const size = this.shopifyProduct.variants.find(
          (v) => v.id === parseInt(this.$route.query.variant)
        )

        if (size) {
          selectedSize = size.opt.size.value
        }
      }

      return selectedSize
    },

    init() {
      this.$nuxt.$on(EVENTS.OPEN_TESTIMONIAL_MODAL, () => {
        this.showTestimonialsModal = true
      })

      this.$nextTick(() => {
        this.$nuxt.$emit(
          EVENTS.PRODUCT_COLOR_UPDATED,
          this.selectedDimensions.color
        )
      })
    },

    onColorChange(color) {
      this.$nuxt.$emit(EVENTS.PRODUCT_COLOR_UPDATED, color)

      this.$nextTick(() => {
        this.updateSelectedColorScroll()
        this.setDimensionInUrl('color', color)
      })
    },

    handleShowSizeSelector() {
      this.showSizeSelector = !this.showSizeSelector

      this.errors.size = ERRORS_TYPE.NONE
      this.errors.addToCart = ERRORS_TYPE.NONE

      this.$nextTick(() => {
        this.updateSelectedColorScroll()
      })
    },
    handleSelectSize(size) {
      this.selectedDimensions.size = size
      this.errors.size = ERRORS_TYPE.NONE
      this.errors.addToCart = ERRORS_TYPE.NONE
    },

    handleReducePurchaseSticky() {
      this.reducePurchase = !this.reducePurchase

      this.$nextTick(() => {
        this.updateHasColorsOverflow()
      })
    },

    /**
     * Gère les paramètres de la route
     */
    setDimensionInUrl(dimension, value) {
      if (process.client) {
        const url = new URL(window.location.href)

        if (value && !url.searchParams.has('variant')) {
          url.searchParams.set(dimension, value)
        } else {
          url.searchParams.delete(dimension)
        }

        window.history.replaceState(null, null, url)
      }
    },
    setVariantUrlParam() {
      if (process.client) {
        const url = new URL(window.location.href)

        if (this.selectedVariant) {
          url.searchParams.delete('color')
          url.searchParams.set('variant', this.selectedVariant.id)
        } else {
          url.searchParams.delete('variant')
        }

        window.history.replaceState(null, null, url)
      }
    },

    /**
     * Ajoute le produit au panier
     */
    addToCart() {
      if (!this.selectedVariant) {
        if (!this.showSizeSelector) {
          this.showSizeSelector = true
        } else {
          this.errors.size = ERRORS_TYPE.EMPTY
        }

        return
      }

      const customAttributes = []
      customAttributes.push({ key: '_order_type', value: this.orderType })
      customAttributes.push({
        key: '_delivery',
        value: this.$t(this.deliveryText.ref, this.deliveryText.options),
      })
      customAttributes.push({
        key: '_delivery_last_updated_at',
        value: new Date().toJSON(),
      })
      customAttributes.push({
        key: '_slug',
        value: this.productDocument.uid,
      })
      customAttributes.push({ key: '_locale', value: this.$i18n.locale })
      customAttributes.push({ key: '_basket_date', value: new Date().toJSON() })

      if (this.productDocument.care_guide) {
        customAttributes.push({
          key: '_guide-entretien',
          value: this.productDocument.care_guide.uid,
        })
      }

      if (this.delivery && !isNaN(this.delivery.getTime())) {
        customAttributes.push({
          key: '_delivery_date',
          value: this.delivery,
        })
      }

      if (this.productHasBeenAccessedFromUpsell) {
        customAttributes.push({
          key: '_upsell',
          value: 'true',
        })
      }

      const cartItem = {
        merchandiseId: ShopifyBase64.encode(
          SHOPIFY_TYPES.VARIANT,
          this.selectedVariant.id
        ),
        quantity: 1,
        attributes: customAttributes,
      }

      this.addItemToCart([cartItem])
        .then((_) => {
          this.$track.addToCart(
            this.productDocument.title,
            this.shopifyProduct,
            this.selectedVariant,
            this.shopifyProduct.currency,
            this.cart
          )

          // AB Tasty - Si AB Test sur le produit
          if (this.productAbTest) {
            this.$track.addToCartAbTest(this.productDocument.uid)
          }

          document
            .getElementById('linkOpenCart')
            .dispatchEvent(new Event('click'))
        })
        .catch((err) => {
          this.$logError.captureException(err)
          this.errors.addToCart = ERRORS_TYPE.FAIL
        })

      if (this.authenticated) {
        return services.laPosteService.addToCart(
          this.customer.email,
          this.productDocument.uid,
          this.$i18n.locale.slice(0, 2)
        )
      }

      if (this.connectedEmail && this.connectedEmail !== '') {
        return services.laPosteService.addToCart(
          this.connectedEmail,
          this.productDocument.uid,
          this.$i18n.locale.slice(0, 2)
        )
      }
    },

    /**
     * active le rendu d'overflow-x pour les couleurs
     */
    updateHasColorsOverflow() {
      if (this.$refs.purchaseColors) {
        const el =
          this.$refs.purchaseColors.getElementsByClassName('picker__elements')
        if (el && el[0] && el[0].scrollWidth > el[0].clientWidth) {
          this.$refs.purchaseColors.classList.add('has-overflow-x')

          el[0].addEventListener('scroll', () => {
            // le scroll est à la fin
            if (el[0].scrollLeft + el[0].clientWidth >= el[0].scrollWidth) {
              this.$refs.purchaseColors.classList.add('scroll-end')
            } else {
              this.$refs.purchaseColors.classList.remove('scroll-end')
            }
          })
        } else {
          this.$refs.purchaseColors.classList.remove('has-overflow-x')

          if (el && el[0]) {
            el[0].removeEventListener('scroll')
          }
        }
      }
    },

    updateSelectedColorScroll() {
      if (this.$refs.purchaseColors) {
        const selectedColor = this.$refs.purchaseColors.getElementsByClassName(
          'picker-item--active'
        )
        if (selectedColor && selectedColor[0]) {
          selectedColor[0].scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          })
        }
      }
    },

    handleShowTestimonials() {
      this.showTestimonialsModal = true
    },

    handleShowModal(type) {
      this.modal.show = true

      if (this.modal.content === null || this.modal.type !== type) {
        this.modal.loading = true

        let id = null
        if (type === 'delivery') {
          id = this.productDocument.delivery_and_returns._ref
        } else if (type === 'size') {
          id = this.productDocument.size_guide._ref
        }

        services.sanityService
          .getById({
            id,
            lang: this.$i18n.locale.slice(0, 2),
          })

          .then((document) => {
            this.modal.content = document
            this.modal.type = type
          })
          .catch((err) => {
            this.$logError.captureException(err)
          })
          .finally(() => {
            this.modal.loading = false
          })
      }
    },
    handleHideModal() {
      if (this.modal.show || this.showTestimonialsModal) {
        this.modal.show = false
        this.showTestimonialsModal = false
      } else {
        this.showSizeSelector = false
      }
    },

    handleOverlayClick() {
      if (this.showSizeSelector) {
        this.handleShowSizeSelector()
      }
    },

    /**
     * Kleep
     */
    initKleep() {
      const s = document.createElement('script')
      s.type = 'text/javascript'
      s.async = true
      s.src = 'https://module.kleep.ai/api/widget'
      s.id = 'kleepWidget'
      s.onload = () => {
        this.runKleep()
      }
      document.body.appendChild(s)
    },
    runKleep() {
      if (typeof window.kleep !== 'undefined') {
        kleep.load({
          domain: 'asphalte.com',
          lang: this.$i18n.locale.slice(0, 2),
          selectors: {
            sizing: '#kleep-module-sizing',
          },
          product_id: `${this.shopifyProduct.id}`,
          getSizes: () => {
            const shopifyVariants = this.shopifyProduct.variants
            return shopifyVariants
              .sort((a, b) => {
                const orderedColors = this.colorsDimension.map((c) => c.value)
                if (orderedColors.length > 0) {
                  if (
                    orderedColors.indexOf(a.opt.color.value) <
                    orderedColors.indexOf(b.opt.color.value)
                  )
                    return -1
                  if (
                    orderedColors.indexOf(a.opt.color.value) >
                    orderedColors.indexOf(b.opt.color.value)
                  )
                    return 1
                }
                return 0
              })
              .map((v) => ({
                color: v.opt.color.value,
                label: v.opt.size.value,
                variantId: `${v.id}`,
                quantity: this.productIsOnSale ? v.available : 0,
              }))
          },
          addToCart: (variantId) => {
            const v = this.shopifyProduct.variants.find(
              (v) => v.id === parseInt(variantId)
            )
            if (v) {
              this.selectedVariant = v
              this.addToCart()
            }
          },
          selectSize: (variantId) => {
            const v = this.shopifyProduct.variants.find(
              (v) => v.id === parseInt(variantId)
            )
            if (v) {
              this.selectedVariant = v
            }
          },
        })
      }
    },
  },
}
</script>

<style lang="scss">
.purchase-sticky {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  inset: auto 0 0;
  padding: calc(var(--spacing) * 2) var(--spacing)
    calc(env(safe-area-inset-bottom) + var(--spacing));
  z-index: 1000;
  background: linear-gradient(180deg, RGB(0 0 0 / 0) 0%, RGB(0 0 0 / 0.5) 100%);
  transition: all 0.3s var(--asphalte-animation-function);

  &.has-full-page-modal {
    z-index: 3000;
  }

  .overlay {
    position: relative;
    flex: 1 0 auto;
    pointer-events: none;

    &::after {
      content: '';
      position: absolute;
      inset: calc(var(--spacing) * -2) calc(var(--spacing) * -1) 0;
    }
  }

  .button-as-link {
    background-color: transparent;
    border: 0;
    padding: 0;
    margin: 0;
  }

  .add-to-cart {
    width: 100%;
  }

  .purchase__inner {
    background: RGB(0 0 0 / 0.2);
    backdrop-filter: blur(12.5px);
    padding: calc(var(--spacing) * 0.4);
    transition: all 0.3s var(--asphalte-animation-function);

    h1 {
      font-size: var(--big-font-size);
      letter-spacing: 0;
      margin-bottom: 0;
    }
  }

  .purchase__market {
    font-size: var(--extra-small-font-size);
    line-height: 1.33;
    background-color: white;
    padding: calc(var(--spacing) * 0.4) calc(var(--spacing) * 0.6);
    gap: calc(var(--spacing) * 0.2);
    transition: all 0.3s var(--asphalte-animation-function);
  }

  .purchase__title {
    height: rem(26px);
    transition: all 0.3s var(--asphalte-animation-function);
  }

  .button-reducer {
    padding: calc(var(--spacing) * 0.6) calc(var(--spacing) * 0.8);
    background: RGB(0 0 0 / 0.2);
    backdrop-filter: blur(12.5px);
    position: relative;
    z-index: 3;
    transition: all 0.3s var(--asphalte-animation-function);

    .icon {
      display: block;
      width: rem(16px);
      height: rem(16px);
      transition: all 0.3s var(--asphalte-animation-function);
    }
  }

  .purchase__selectors {
    max-width: 100%;
    gap: calc(var(--spacing) * 0.6);
    transition: all 0.3s var(--asphalte-animation-function), padding-right 0s;
  }

  .picker__label {
    font-family: var(--primary-font-family);
    font-size: var(--extra-small-font-size);
    color: var(--tertiary-color);
    font-weight: 600;
    margin-bottom: calc(var(--spacing) * 0.6);
    letter-spacing: 0.2px;
  }

  .purchase__colors {
    flex: 1 1 auto;
    position: relative;
    overflow: hidden;

    &.has-overflow-x {
      &::before {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        width: rem(9px);
        height: rem(32px);
        background: linear-gradient(
          90deg,
          RGB(0 0 0 / 0) 0%,
          RGB(0 0 0 / 0.2) 100%
        );
        transition: opacity 0.3s;
      }

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        width: rem(1px);
        height: rem(32px);
        background-color: #f5f5f5;
        opacity: 0.2;
      }

      &.scroll-end {
        &::before {
          opacity: 0;
        }
      }
    }

    .picker__elements {
      width: 100%;
      gap: 0 calc(var(--spacing) * 0.4);
      padding: rem(1px);
      padding-right: calc(var(--spacing) * 0.4);
      margin: 0;
      flex-wrap: nowrap;
      justify-content: flex-start;
      overflow-x: auto;
      -ms-overflow-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .picker__label {
      height: rem(18px);
      transition: all 0.3s var(--asphalte-animation-function);
    }

    .picker--color {
      margin-bottom: 0;
    }

    .picker-item--bg {
      --line-color: RGB(255 255 255 / 0);
    }

    .picker-item__bg::after {
      box-shadow: 0 0 0 rem(1px) var(--line-color);
    }

    .picker-item--active {
      --line-color: var(--tertiary-color);
      --line-position: #{rem(-3px)};
    }

    .picker__element {
      margin: 0;

      &.break {
        display: none;
      }
    }

    .picker-item {
      min-width: rem(32px);
      min-height: rem(32px);
    }
  }

  .purchase-modal {
    .picker__label {
      color: var(--secondary-color);
      margin-bottom: 0;
    }
  }

  .purchase__size-selector {
    flex-shrink: 0;
    transition: all 0.3s var(--asphalte-animation-function);
  }

  .purchase__size-picker {
    background-color: transparent;
    border: 0;
    padding: rem(1px) 0;

    .inner {
      min-height: rem(32px);
      gap: calc(var(--spacing) * 0.6);
      padding: 0 calc(var(--spacing) * 0.6);
      border-radius: 4px;
      background-color: RGB(245 245 245 / 0.2);
      letter-spacing: 0.2px;
    }
  }

  .size-picker {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    gap: calc(var(--spacing) * 0.6);

    &--errors {
      background-color: RGB(255 46 0 / 0.1);
    }

    &__item {
      position: relative;
      min-height: rem(56px);
      background-color: #f5f5f5;
      color: var(--secondary-color);
      font-size: var(--small-font-size);
      font-weight: 600;
      border: 0;

      span {
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: rem(-2px);
          left: 50%;
          width: 100%;
          height: rem(1px);
          background-color: var(--secondary-color);
          transform: translateX(-50%);
        }
      }

      &::after {
        content: '';
        position: absolute;
        inset: 0;
        border: 2px solid RGB(11 75 141 / 0.8);
        opacity: 0;
        transform: scale(1.1);
        transition: opacity 0.3s var(--asphalte-animation-function),
          transform 0s var(--asphalte-animation-function) 0.3s;
      }

      &.size-picker__item--active {
        &::after {
          opacity: 1;
          transform: scale(1);
          transition: all 0.3s var(--asphalte-animation-function);
        }
      }
    }
  }

  .purchase__bottom {
    height: rem(37px);
    transition: all 0.3s var(--asphalte-animation-function);

    button {
      background-color: transparent;
      border: 0;
      margin: 0;
      padding: 0;
    }

    .icon {
      width: rem(14px);
      height: rem(14px);
    }
  }

  .prices {
    gap: var(--spacing);
  }

  .price__price {
    font-size: var(--big-font-size);
  }

  .price--compare {
    color: RGB(255 255 255 / 0.6);
  }

  .kleep-button {
    padding: var(--spacing) 0;

    .kleep-underline {
      color: var(--secondary-color);
      font-weight: 600;
      text-transform: uppercase;
      padding-bottom: 0;

      &::after {
        content: none;
      }
    }

    .kleep-default {
      font-size: var(--label-font-size) !important;
      line-height: 1;
    }
  }

  .purchase-testimonials {
    padding: calc(var(--spacing) * 0.4) calc(var(--spacing) * 1.4)
      calc(var(--spacing) * 1.4);
    gap: calc(var(--spacing) * 1.6);

    .separator {
      width: rem(1px);
      align-self: stretch;
      background-color: var(--secondary-color-4);
    }
  }

  &.size-selector-open {
    height: 100%;
    background-color: RGB(0 0 0 / 0.5);

    .overlay {
      pointer-events: all;
    }
  }

  &.reduced {
    background: transparent;
    padding: 0 var(--spacing)
      calc(env(safe-area-inset-bottom) + calc(var(--spacing)));

    .purchase__inner {
      background: transparent;
      backdrop-filter: blur(0);
      padding-left: 0;
      padding-right: 0;
    }

    .button-reducer {
      transform: translateY(#{rem(40px)});

      .icon {
        transform: rotate(180deg);
      }
    }

    .purchase__market {
      opacity: 0;
    }

    .purchase__title,
    .purchase__bottom {
      padding-top: 0;
      padding-bottom: 0;
      opacity: 0;
      height: 0;
    }

    .purchase__colors .picker__label {
      opacity: 0;
      height: 0;
      margin-bottom: 0;
    }

    .purchase__selectors {
      padding-top: 0;
      padding-right: rem(55px);
    }

    .purchase__size-selector {
      opacity: 0;
      height: 0;
      width: 0;
      transform: translateX(30px);
    }
  }
}
</style>
